<div class="containers">
  <div class="content-busca">
    <div class="content">
      <h1 class="title">
        Encontrar o lar dos seus sonhos<br *ngIf="!mobile"> em Santa Maria nunca foi tão fácil
      </h1>
    </div>

    <div class="section-busca">
      <div class="search-box">
        <div class="navigation-all-item">
          <nav class="nav-list">
            <div class="btn-group" role="group">
              <button type="button" class="btn" [class.active]="selectedCompra === 2"
                (click)="selectedCompra = 2">Comprar</button>
              <button type="button" class="btn" [class.active]="selectedCompra === 1"
                (click)="selectedCompra = 1">Alugar</button>
            </div>
          </nav>

        </div>
        <div class="div-campos" *ngIf="isCodigo">
          <div class="icon-inicial">
            <i class="fa-sharp fa-solid fa-location-dot" style="color: #000000;"></i>
          </div>
          <div class="mat-select-custom">
            <div style="margin: 10px auto 0;">
              <p class="p-inicial">Código ou palavra-chave:</p>
              <div class="select-wrapper">
                <div class="selected-option">
                  <input autocomplete="off" style="max-width: 300px;" type="text" [(ngModel)]="searchCod"
                    placeholder="Separar os códigos por virgulas" class="autocomplete-input"
                    (ngModelChange)="onSearchChange($event)" matInput [matAutocomplete]="auto" />
                  <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
                    @for (tip of tips; track tip) {
                    <mat-option [value]="tip">{{tip}}</mat-option>
                    }
                  </mat-autocomplete>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 🔹 Selecione um Bairro -->
        <div class="div-campos" *ngIf="!isCodigo">
          <div class="icon-inicial">
            <i class="fa-sharp fa-solid fa-location-dot" style="color: #000000;"></i>
          </div>
          <div class="mat-select-custom">
            <div style="margin: 10px auto 0;">
              <p class="p-inicial">Onde</p>
              <div class="select-wrapper">
                <div class="autocomplete-input" (click)="toggleDropdownBairro($event)">
                  <div class="scroll-container">
                    <!-- 🔹 Exibir bairros selecionados dentro do input -->
                    <div class="selected-items">
                      <span *ngFor="let nome of selectedBairrosNomes" class="tag">
                        {{ nome }} <i (click)="removeBairro(nome)" class="fa fa-times remove-tag"></i>
                      </span>
                    </div>
          
                    <!-- 🔹 Input para busca e seleção -->
                    <input type="text" [(ngModel)]="searchTextBairro" (input)="filterOptionsBairro()"
                      (keydown.enter)="addBairroFromInput()" (keydown.backspace)="removeLastBairro()"
                      placeholder="Busque por Bairro..." class="autocomplete-input" (focus)="dropdownOpenBairro = true"
                      (click)="keepDropdownOpen($event)" />
                  </div>
                </div>
          
                <!-- 🔹 Dropdown de sugestões -->
                <div class="dropdown-options" *ngIf="dropdownOpenBairro">
                  <label *ngFor="let bairro of filteredBairros" class="option">
                    <input type="checkbox" class="option-checkbox" (change)="toggleSelectionBairro(bairro)"
                      [checked]="isBairroSelected(bairro.nome)" />
                    <span class="custom-checkbox"></span>
                    {{ bairro.nome }}
                  </label>
          
                  <div class="no-results" *ngIf="filteredBairros.length === 0">
                    Nenhum bairro encontrado
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>

        <!-- 🔹 Selecione um Tipo de Imóvel -->
        <div class="div-campos" *ngIf="!isCodigo">
          <div class="icon-inicial">
            <i class="fa-sharp fa-solid fa-house"></i>
          </div>
          <div class="mat-select-custom">
            <div style="margin: 10px auto 0;">
              <p class="p-inicial">Tipo</p>
              <div class="select-wrapper">
                <div class="autocomplete-input" (click)="toggleDropdownTip($event)">
                  <div class="scroll-container">
                    <span *ngIf="selectedTiposNomes.length > 0; else placeholder">
                      {{ selectedTiposNomes.join(', ') }}
                    </span>
                  </div>
                  <ng-template #placeholder>Busque por categoria</ng-template>
                </div>
                <div class="dropdown-options" *ngIf="dropdownOpenTip">
                  <label *ngFor="let subtipo of subTipos;let i = index;" class="option">
                    <input autocomplete="off" class="option-checkbox" type="checkbox" (change)="toggleSelectionTip(i)"
                      [checked]="subtipo.checked" />
                    <span class="custom-checkbox"></span>

                    {{ subtipo.name }}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div [ngClass]="mobile ? 'circle-icon-busca-mobile' : 'circle-icon-busca'" (click)="acessaImoveis()">
          <ng-container *ngIf="mobile">Buscar </ng-container>
          <i class="fa-solid fa-magnifying-glass" style="color: #fff; zoom:1.6;"></i>
        </div>
      </div>
    </div>
    <div class="content-ckbx">
      <div class="form-check">
        <input class="form-check-input" type="checkbox" id="flexCheckDefault" (change)="checkCod()"
          [checked]="isCodigo">
        <label class="form-check-label" for="flexCheckDefault">
          Buscar por código ou palavra-chave
        </label>
      </div>

      <!-- <input type="checkbox" ><p>Buscar por Código</p> -->
    </div>
  </div>
</div>

<app-title title="Encontre seu imóvel em Santa Maria"></app-title>

<div class="content-2" style="margin: auto!important;">
  <div class="div-small-content">
    <div class="btn-small-content" (click)="openModal('IMOVEIS_UFN')">Próximos à UFN
      <div class="circle-icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="30" height="26" fill="#fff" stroke="#fff"
          stroke-width="2" class="size-1">
          <path fill-rule="evenodd"
            d="M16.28 11.47a.75.75 0 0 1 0 1.06l-7.5 7.5a.75.75 0 0 1-1.06-1.06L14.69 12 7.72 5.03a.75.75 0 0 1 1.06-1.06l7.5 7.5Z"
            clip-rule="evenodd" />
        </svg>
      </div>
    </div>
    <div class="btn-small-content" id="openModal" (click)="openModal('IMOVEIS_CALCADAO')">Próximos<br>ao Calçadão
      <div class="circle-icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="30" height="26" fill="#fff" stroke="#fff"
          stroke-width="2" class="size-1">
          <path fill-rule="evenodd"
            d="M16.28 11.47a.75.75 0 0 1 0 1.06l-7.5 7.5a.75.75 0 0 1-1.06-1.06L14.69 12 7.72 5.03a.75.75 0 0 1 1.06-1.06l7.5 7.5Z"
            clip-rule="evenodd" />
        </svg>
      </div>
    </div>
    <div class="btn-small-content" id="openModal" (click)="openModal('IMOVEIS_UFSM')">Próximos à UFSM
      <div class="circle-icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="30" height="26" fill="#fff" stroke="#fff"
          stroke-width="2" class="size-1">
          <path fill-rule="evenodd"
            d="M16.28 11.47a.75.75 0 0 1 0 1.06l-7.5 7.5a.75.75 0 0 1-1.06-1.06L14.69 12 7.72 5.03a.75.75 0 0 1 1.06-1.06l7.5 7.5Z"
            clip-rule="evenodd" />
        </svg>
      </div>
    </div>

    <div class="btn-small-content" id="openModal" (click)="openModal('IMOVEIS_AREA_MILITAR')">Próximos à<br>Área Militar
      <div class="circle-icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="30" height="26" fill="#fff" stroke="#fff"
          stroke-width="2" class="size-1">
          <path fill-rule="evenodd"
            d="M16.28 11.47a.75.75 0 0 1 0 1.06l-7.5 7.5a.75.75 0 0 1-1.06-1.06L14.69 12 7.72 5.03a.75.75 0 0 1 1.06-1.06l7.5 7.5Z"
            clip-rule="evenodd" />
        </svg>
      </div>
    </div>
  </div>
</div>

<app-title title="Empreendimentos"></app-title>
<app-empreendimentos> </app-empreendimentos>


<app-title title="Bairros destaque"></app-title>
<app-bairros-gallery></app-bairros-gallery>


<app-title title="Os melhores imóveis para você comprar"></app-title>
<div class="body-lista">
  <div id="carouselImoveisPrincipais" class="carousel slide" data-bs-ride="carousel" data-bs-interval="3000">
    <!-- Indicadores -->
    <div class="carousel-indicators" *ngIf="!mobile">
      <button *ngFor="let group of imoveisDestaqueVendaGrouped; let i = index"
        [attr.data-bs-target]="'#carouselImoveisPrincipais'" [attr.data-bs-slide-to]="i"
        [class.active]="i === 0"></button>
    </div>

    <!-- Slides -->
    <div class="carousel-inner">
      <div *ngFor="let group of imoveisDestaqueVendaGrouped; let i = index" class="carousel-item"
        [class.active]="i === 0">
        <div class="cards">
          <div class="card-destaque" *ngFor="let imovel of group">
            <div class="header-card">
              <div class="div-img">
                <!-- <img [src]="imovel.imagens[0].link_thumb" alt="Imagem" class="image-card"> -->
                <app-swiper-imagens [imagens]="imovel.imagens" [imovelSlug]="imovel.slug"></app-swiper-imagens>
              </div>
            </div>
            <div class="body-card" (click)="abreImovel(imovel.slug)">
              <p class="tipo"><span><b>{{ imovel.subtipo }}</b></span><span style="font-size: 13px;">{{ imovel.codigo
                  }}</span></p>
              <p class="titulo">{{ imovel | enderecoImovel }}</p>
              <div class="div-icones-geral">
                <p class="valor">{{ (imovel?.valor_locacao || imovel?.valor_venda) | currency: 'BRL' }}<span
                    *ngIf="imovel?.valor_locacao">/mês</span></p>
                <div class="div-icones-imovel">
                  <div style="margin-right: 5px;"
                    *ngIf="!!imovel?.area_privativa && imovel.area_privativa > 0 && imovel.subtipo | deveExibirAtributo: 'area_privativa'">
                    <p style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
                      <i class="fa-solid fa-ruler-combined" style="margin: 0px 5px"></i>
                      <b>{{ imovel?.area_privativa | number:'1.0-0' }} {{imovel.medida}}</b>
                    </p>
                  </div>

                  <div style="display: flex; flex-direction: column; align-items: start; justify-content: start;"
                    *ngIf="imovel?.dormitorios && imovel?.subtipo | deveExibirAtributo: 'dormitorios'"
                    style="margin: 0px 5px 0 0px;">
                    <p style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
                      <i class="fa-solid fa-bed" style="margin: 0px 5px"></i>
                      <b>{{ imovel?.dormitorios }}
                        <sup *ngIf="imovel?.suites && imovel.suites > 0" style="font-weight: 600; font-size: 0.75em;">{{
                          imovel.suites }}</sup>
                      </b>
                    </p>
                  </div>
                  <div *ngIf="imovel?.subtipo | deveExibirAtributo: 'banheiros'" style="margin: 0px 1px 0 1px;">
                    <p style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
                      <i class="fa-solid fa-shower" style="margin-left: 5px;"></i>
                      <b>{{ imovel?.banheiros ?? 0 }}</b>

                    </p>
                  </div>
                  <div *ngIf="imovel?.subtipo | deveExibirAtributo: 'garagens'" style="margin: 0px 1px 0 1px;">
                    <p style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
                      <i class="fa-solid fa-car" style="margin-left: 5px;"></i>
                      <b>{{ imovel?.garagens ?? 0 }}</b>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Controles de navegação -->
    <button class="carousel-control-prev" type="button" data-bs-target="#carouselImoveisPrincipais" data-bs-slide="prev"
      *ngIf="!mobile">
      <div class="circle-icon">
        <svg style="margin-left:-3px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="30" height="26"
          fill="#000" stroke="#000" stroke-width="2" class="size-1" transform="scale(-1, 1)">
          <path fill-rule="evenodd"
            d="M16.28 11.47a.75.75 0 0 1 0 1.06l-7.5 7.5a.75.75 0 0 1-1.06-1.06L14.69 12 7.72 5.03a.75.75 0 0 1 1.06-1.06l7.5 7.5Z"
            clip-rule="evenodd" />
        </svg>
      </div>
    </button>
    <button class="carousel-control-next" type="button" data-bs-target="#carouselImoveisPrincipais" data-bs-slide="next"
      *ngIf="!mobile">
      <div class="circle-icon">
        <svg style="margin-right:-3px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="30" height="26"
          fill="#000" stroke="#000" stroke-width="2" class="size-1">
          <path fill-rule="evenodd"
            d="M16.28 11.47a.75.75 0 0 1 0 1.06l-7.5 7.5a.75.75 0 0 1-1.06-1.06L14.69 12 7.72 5.03a.75.75 0 0 1 1.06-1.06l7.5 7.5Z"
            clip-rule="evenodd" />
        </svg>
      </div>
    </button>
  </div>
</div>

<app-title title="Os melhores imóveis para você alugar"></app-title>
<div class="body-lista"
  style="background: #f0f0f0!important; padding-top: 10px; box-shadow: rgba(50, 50, 93, 0.25) 0px -30px 60px -12px inset;">
  <div id="carouselImoveisDestaque" class="carousel slide" data-bs-ride="carousel" data-bs-interval="3000">
    <!-- Indicadores -->
    <div class="carousel-indicators" *ngIf="!mobile">
      <button *ngFor="let group of imoveisDestaqueLocacaoGrouped; let i = index"
        [attr.data-bs-target]="'#carouselImoveisDestaque'" [attr.data-bs-slide-to]="i"
        [class.active]="i === 0"></button>
    </div>

    <!-- Slides -->
    <div class="carousel-inner">
      <div *ngFor="let group of imoveisDestaqueLocacaoGrouped; let i = index" class="carousel-item"
        [class.active]="i === 0">
        <div class="cards-destaque-aluguel">
          <div class="card-destaque-aluguel" *ngFor="let imovel of group">
            <div class="header-card">
              <div class="div-img">
                <!-- <img [src]="imovel.imagens[0].link_thumb" alt="Imagem" class="image-card-destaque"> -->
                <app-swiper-imagens [imagens]="imovel.imagens" [imovelSlug]="imovel.slug"></app-swiper-imagens>
              </div>
            </div>
            <div class="body-card" (click)="abreImovel(imovel.slug)">
              <p class="tipo"><span><b>{{ imovel.subtipo }}</b></span><span style="font-size: 13px;">{{ imovel.codigo
                  }}</span></p>
              <p class="titulo">{{ imovel | enderecoImovel }}</p>
              <div class="div-icones-geral">
                <p *ngIf="(imovel?.valor_locacao ?? imovel?.valor_venda ?? 0 ) > 0" class="valor">{{
                  (imovel?.valor_locacao ||
                  imovel?.valor_venda) | currency: 'BRL' }}<span *ngIf="imovel?.valor_locacao">/mês</span>
                </p>
                <p *ngIf="(imovel?.valor_locacao ?? imovel?.valor_venda ?? 0 ) === 0" class="valor">Sob Consulta</p>
                <div class="div-icones-imovel">
                  <div style="margin-right: 5px;"
                    *ngIf="!!imovel?.area_privativa && imovel.area_privativa > 0 && imovel.subtipo | deveExibirAtributo: 'area_privativa'">
                    <p style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
                      <i class="fa-solid fa-ruler-combined" style="margin: 0px 5px"></i>

                      <b>{{ imovel?.area_privativa | number:'1.0-0' }} {{imovel.medida}}</b>
                    </p>
                  </div>

                  <div style="display: flex; flex-direction: column; align-items: start; justify-content: start;"
                    *ngIf="imovel?.dormitorios && imovel?.subtipo | deveExibirAtributo: 'dormitorios'"
                    style="margin: 0px 5px 0 0px;">
                    <p style="display: flex; flex-direction: column; align-items: center; justify-content: center;">


                      <i class="fa-solid fa-bed" style="margin: 0px 5px"></i>
                      <b>{{ imovel?.dormitorios }}
                        <sup *ngIf="imovel?.suites && imovel.suites > 0" style="font-weight: 600; font-size: 0.75em;">{{
                          imovel.suites }}</sup>
                      </b>
                    </p>
                  </div>
                  <div *ngIf="imovel?.subtipo | deveExibirAtributo: 'banheiros'" style="margin: 0px 1px 0 1px;">
                    <p style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
                      <i class="fa-solid fa-shower" style="margin-left: 5px;"></i>
                      <b>{{ imovel?.banheiros ?? 0 }}</b>

                    </p>
                  </div>
                  <div *ngIf="imovel?.subtipo | deveExibirAtributo: 'garagens'" style="margin: 0px 1px 0 1px;">
                    <p style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
                      <i class="fa-solid fa-car" style="margin-left: 5px;"></i>
                      <b>{{ imovel?.garagens ?? 0 }}</b>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Controles de navegação -->
    <button class="carousel-control-prev" type="button" data-bs-target="#carouselImoveisDestaque" data-bs-slide="prev"
      *ngIf="!mobile">
      <div class="circle-icon">
        <svg style="margin-left:-3px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="30" height="26"
          fill="#000" stroke="#000" stroke-width="2" class="size-1" transform="scale(-1, 1)">
          <path fill-rule="evenodd"
            d="M16.28 11.47a.75.75 0 0 1 0 1.06l-7.5 7.5a.75.75 0 0 1-1.06-1.06L14.69 12 7.72 5.03a.75.75 0 0 1 1.06-1.06l7.5 7.5Z"
            clip-rule="evenodd" />
        </svg>
      </div>
    </button>
    <button class="carousel-control-next" type="button" data-bs-target="#carouselImoveisDestaque" data-bs-slide="next"
      *ngIf="!mobile">
      <div class="circle-icon">
        <svg style="margin-right:-3px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="30" height="26"
          fill="#000" stroke="#000" stroke-width="2" class="size-1">
          <path fill-rule="evenodd"
            d="M16.28 11.47a.75.75 0 0 1 0 1.06l-7.5 7.5a.75.75 0 0 1-1.06-1.06L14.69 12 7.72 5.03a.75.75 0 0 1 1.06-1.06l7.5 7.5Z"
            clip-rule="evenodd" />
        </svg>
      </div>
    </button>
  </div>
</div>

<app-title title="Imóveis para você investir"></app-title>
<div class="body-lista">
  <div id="carouselImoveisApto" class="carousel slide" data-bs-ride="carousel" data-bs-interval="3000">
    <!-- Indicadores -->
    <div class="carousel-indicators" *ngIf="!mobile">
      <button *ngFor="let group of imoveisDestaqueInvestirGrouped; let i = index"
        [attr.data-bs-target]="'#carouselImoveisApto'" [attr.data-bs-slide-to]="i" [class.active]="i === 0"></button>
    </div>

    <!-- Slides -->
    <div class="carousel-inner">
      <div *ngFor="let group of imoveisDestaqueInvestirGrouped; let i = index" class="carousel-item"
        [class.active]="i === 0">
        <div class="cards">
          <div class="card-destaque" *ngFor="let imovel of group">
            <div class="header-card">
              <div class="div-img">
                <!-- <img [src]="imovel.imagens[0].link_thumb" alt="Imagem" class="image-card"> -->
                <app-swiper-imagens [imagens]="imovel.imagens" [imovelSlug]="imovel.slug"></app-swiper-imagens>
              </div>
            </div>
            <div class="body-card" (click)="abreImovel(imovel.slug)">
              <p class="tipo"><span><b>{{ imovel.subtipo }}</b></span><span style="font-size: 13px;">{{ imovel.codigo
                  }}</span></p>
              <p class="titulo">{{ imovel | enderecoImovel }}</p>
              <div class="div-icones-geral">

                <p *ngIf="(imovel?.valor_locacao ?? imovel?.valor_venda ?? 0 ) > 0" class="valor">{{
                  (imovel?.valor_locacao || imovel?.valor_venda) | currency: 'BRL' }}<span
                    *ngIf="imovel?.valor_locacao">/mês</span>
                </p>
                <p *ngIf="(imovel?.valor_locacao ?? imovel?.valor_venda ?? 0 ) === 0" class="valor">Sob Consulta</p>

                <!-- <div class="div-icones-imovel">
                  <div style="margin-right: 5px;"
                    *ngIf="!!imovel?.area_privativa && imovel.area_privativa > 0 && imovel.subtipo | deveExibirAtributo: 'area_privativa'">
                    <p>
                      <b>{{ imovel?.area_privativa | number:'1.0-0' }} {{imovel.medida}}</b>
                    </p>
                  </div>

                  <div style="display: flex; flex-direction: column; align-items: start; justify-content: start;"
                    *ngIf="imovel?.dormitorios && imovel?.subtipo | deveExibirAtributo: 'dormitorios'"
                    style="margin: 0px 5px 0 0px;">
                    <p>
                      <b>{{ imovel?.dormitorios }}</b>
                      <i class="fa-solid fa-bed" style="margin: 0px 5px"></i>
                    </p>
                    <p *ngIf="imovel && imovel.suites" style="font-size: 13px; font-weight: 500;">
                      ({{ imovel.suites }} {{ imovel.suites === 1 ? "Suíte" : "Suítes" }})
                    </p>
                  </div>
                  <div *ngIf="imovel?.subtipo | deveExibirAtributo: 'banheiros'" style="margin: 0px 1px 0 1px;">
                    <p>
                      <b>{{ imovel?.banheiros ?? 0 }}</b>
                      <i class="fa-solid fa-shower" style="margin-left: 5px;"></i>

                    </p>
                  </div>
                  <div *ngIf="imovel?.subtipo | deveExibirAtributo: 'garagens'" style="margin: 0px 1px 0 1px;">
                    <p>
                      <b>{{ imovel?.garagens ?? 0 }}</b>
                      <i class="fa-solid fa-car" style="margin-left: 5px;"></i>
                    </p>
                  </div>
                </div> -->

                <div class="div-icones-imovel">

                  <p *ngIf="!!imovel?.area_privativa && imovel.area_privativa > 0 && imovel.subtipo | deveExibirAtributo: 'area_privativa'"
                    style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
                    <i class="fa-solid fa-ruler-combined" style="margin: 0px 5px"></i>
                    <b>{{ imovel?.area_privativa | number:'1.0-0' }} {{imovel.medida}}</b>


                  </p>

                  <p *ngIf="imovel.subtipo | deveExibirAtributo: 'terreno_total'"
                    style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
                    <i class="fa-solid fa-ruler-combined" style="margin: 0px 5px"></i>
                    <b>{{ (imovel?.terreno_total ?? imovel?.area_privativa) | number:'1.0-0' }} {{imovel.medida}} </b>

                    <br />
                  </p>

                  <div style="display: flex; flex-direction: column; align-items: center; justify-content: center;"
                    *ngIf="imovel?.dormitorios && imovel?.subtipo | deveExibirAtributo: 'dormitorios'"
                    style="margin: 0px 5px 0 5px;">
                    <p style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
                      <i class="fa-solid fa-bed" style="margin: 0px 5px"></i>
                      <b>{{ imovel?.dormitorios }}
                        <sup *ngIf="imovel?.suites && imovel.suites > 0" style="font-weight: 600; font-size: 0.75em;">{{
                          imovel.suites }}</sup>
                      </b>

                    </p>
                  </div>

                  <div *ngIf="imovel?.subtipo | deveExibirAtributo: 'banheiros'" style="margin: 0px 1px 0 1px;">
                    <p style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
                      <i class="fa-solid fa-shower" style="margin-left: 5px;"></i>
                      <b>{{ imovel?.banheiros ?? 0 }}</b>

                    </p>
                  </div>
                  <div *ngIf="imovel?.subtipo | deveExibirAtributo: 'garagens'" style="margin: 0px 1px 0 1px;">
                    <p style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
                      <i class="fa-solid fa-car" style="margin-left: 5px;"></i>
                      <b>{{ imovel?.garagens ?? 0 }}</b>
                    </p>
                  </div>


                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Controles de navegação -->
    <button class="carousel-control-prev" type="button" data-bs-target="#carouselImoveisApto" data-bs-slide="prev"
      *ngIf="!mobile">
      <div class="circle-icon">
        <svg style="margin-left:-3px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="30" height="26"
          fill="#000" stroke="#000" stroke-width="2" class="size-1" transform="scale(-1, 1)">
          <path fill-rule="evenodd"
            d="M16.28 11.47a.75.75 0 0 1 0 1.06l-7.5 7.5a.75.75 0 0 1-1.06-1.06L14.69 12 7.72 5.03a.75.75 0 0 1 1.06-1.06l7.5 7.5Z"
            clip-rule="evenodd" />
        </svg>
      </div>
    </button>
    <button class="carousel-control-next" type="button" data-bs-target="#carouselImoveisApto" data-bs-slide="next"
      *ngIf="!mobile">
      <div class="circle-icon">
        <svg style="margin-right:-3px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="30" height="26"
          fill="#000" stroke="#000" stroke-width="2" class="size-1">
          <path fill-rule="evenodd"
            d="M16.28 11.47a.75.75 0 0 1 0 1.06l-7.5 7.5a.75.75 0 0 1-1.06-1.06L14.69 12 7.72 5.03a.75.75 0 0 1 1.06-1.06l7.5 7.5Z"
            clip-rule="evenodd" />
        </svg>
      </div>
    </button>
  </div>
</div>

<div class="content-4">
  <h1 class="title-2" style="color: #fff!important; margin-bottom: 40px !important;">
    De pessoas para pessoas
    <div class="style-div"></div>
  </h1>
  <p style="color: #fff!important;">Clique e conheça nossa equipe de vendas</p>
</div>
<app-corretores-gallery [mobile]="mobile"></app-corretores-gallery>


<app-financiamento-card></app-financiamento-card>


<app-title title="Tem sempre uma Cancian perto de você"></app-title>
<app-lojas></app-lojas>

<!-- <div class="content-2">
  <h1 class="title-2">
    O que dizem nossos clientes
    <div class="style-div"></div>
  </h1>
</div>
<div class="container-clientes">
  <div class="card-cliente">
    <img src="../../assets/corretor.webp" alt="Profile Picture">
    <div class="card-content">
      <div class="card-title-cli">Valnei Beltrame</div>
      <div class="card-sub-title-cli">Diretor e proprietário da Beltrame Casa e Construção</div>
      <div class="card-text-cli">Falar da Cancian Imóveis, é falar de uma empresa séria, <br>
        honesta, competente, que está há 10 anos no mercado <br>
        sendo uma empresa veterana. Temos parceira muito <br>
        boa, Beltrame com a Cancian, trabalhamos muito
      </div>
    </div>
  </div>

  <div class="card-cliente" *ngIf="!mobile">
    <img src="../../assets/corretor.webp" alt="Profile Picture">
    <div class="card-content">
      <div class="card-title-cli">Alessandra Sehn</div>
      <div class="card-sub-title-cli">Diretor e proprietário da Beltrame Casa e Construção</div>
      <div class="card-text-cli">Falar da Cancian Imóveis, é falar de uma empresa séria, <br>
        honesta, competente, que está há 10 anos no mercado <br>
        sendo uma empresa veterana. Temos parceira muito <br>
        boa, Beltrame com a Cancian, trabalhamos muito
      </div>
    </div>
  </div>

  <div class="card-cliente" *ngIf="!mobile">
    <img src="../../assets/corretor.webp" alt="Profile Picture">
    <div class="card-content">
      <div class="card-title-cli">Lucas Ruppelt</div>
      <div class="card-sub-title-cli">Diretor e proprietário da Beltrame Casa e Construção</div>
      <div class="card-text-cli">Falar da Cancian Imóveis, é falar de uma empresa séria, <br>
        honesta, competente, que está há 10 anos no mercado <br>
        sendo uma empresa veterana. Temos parceira muito <br>
        boa, Beltrame com a Cancian, trabalhamos muito
      </div>
    </div>
  </div>

  <div class="card-cliente" *ngIf="!mobile">
    <img src="../../assets/corretor.webp" alt="Profile Picture">
    <div class="card-content">
      <div class="card-title-cli">Fernando Weber</div>
      <div class="card-sub-title-cli">Diretor e proprietário da Beltrame Casa e Construção</div>
      <div class="card-text-cli">Falar da Cancian Imóveis, é falar de uma empresa séria, <br>
        honesta, competente, que está há 10 anos no mercado <br>
        sendo uma empresa veterana. Temos parceira muito <br>
        boa, Beltrame com a Cancian, trabalhamos muito
      </div>
    </div>
  </div>
</div> -->